import { isCopySource, useQueryLayerByCopySource } from "../chain/store/useStoreCopySource";
import { useQueryOriginSource } from "../chain/useQueryOriginal"
import { isLayer } from "../chain/validator/useLayerIdentity"
import useLogStack from "./useLogStack";



const compareLayer = (layer1, layer2) => {
    const originalSourceByOld = useQueryOriginSource(layer1);
    const originalSourceByNew = useQueryOriginSource(layer2);
    useLogStack('compareLayer', null, { originalSourceByOld, originalSourceByNew, isSame: originalSourceByNew === originalSourceByOld })
    return originalSourceByNew === originalSourceByOld;
}


const compareCopySource = (source1, source2) => {
    const l1 = useQueryLayerByCopySource(source1);
    const l2 = useQueryLayerByCopySource(source2);
    useLogStack('compareCopySource', null, { originalSourceByOld, originalSourceByNew, isSame: originalSourceByNew === originalSourceByOld })
    return compareLayer(l1, l2);
}


export const useCompareIsEqual = (newValue, oldValue, propertyPath, layer, key,) => {
    if (isLayer(oldValue) && isLayer(newValue)) {
        return compareLayer(newValue, oldValue);
    } else if (isCopySource(newValue) && isCopySource(oldValue)) {
        return compareCopySource(newValue,oldValue)
    }
    return oldValue === newValue
}
